<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    fill="currentColor"
    viewBox="0 0 16 16"
    class="calendar-event-fill-icon"
    :style="{ '--icon-color': color }"
  >
    <title v-if="tooltip">{{ tooltip }}</title>
    <path
      d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
    />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#9ca3af',
  },
  tooltip: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
.calendar-event-fill-icon {
  display: inline-block;
  vertical-align: middle;
  color: var(--icon-color, #9ca3af);
}
</style>
